import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/lib/auth.jsx";
import { toast } from "sonner";
import { Brand } from "@/components/shared/Common";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const next = sp.get("next");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back");
      if (next) nav(next);
      else nav(u.role === "doctor" ? "/doctor" : u.role === "admin" ? "/admin" : "/patient");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="cm-container py-16 flex justify-center">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/"><Brand /></Link>
          <h1 className="cm-h3 mt-4">Welcome back</h1>
        </div>
        <form className="cm-card space-y-4" onSubmit={submit} data-testid="login-form">
          <div><label className="cm-label">Email</label><input className="cm-input" type="email" required value={email} onChange={e=>setEmail(e.target.value)} data-testid="login-email"/></div>
          <div><label className="cm-label">Password</label><input className="cm-input" type="password" required value={password} onChange={e=>setPassword(e.target.value)} data-testid="login-password"/></div>
          <button className="cm-btn-primary w-full" disabled={loading} data-testid="login-submit">{loading?"Signing in…":"Sign in"}</button>
          <div className="text-sm text-center text-[#475569]">
            No account? <Link to="/register" className="text-[#4a90d9] font-semibold" data-testid="login-signup-link">Create one</Link>
          </div>
          <div className="text-xs text-center text-[#94a3b8]">
            Test: <span className="font-mono">patient@carematch.com</span> / <span className="font-mono">Patient@12345</span>
          </div>
        </form>
      </div>
    </div>
  );
}
